import { c as _c } from "react/compiler-runtime";
import { IconSearch2, Portal, Tooltip, useKeyEvent } from '@newfront-insurance/core-ui';
import { useState, type JSX } from 'react';
import { ToolbarButton } from './toolbar-button';
import { GlobalSearch } from '../../search-popover';
import { ACTIVE_GLOBAL_SEARCH_KEY } from '../lib/consts';
export function SearchButton() {
  const $ = _c(10);
  const [isSearchActive, setIsSearchActive] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const {
        activeElement
      } = document;
      if (activeElement?.tagName !== "BODY") {
        return;
      }
      setIsSearchActive(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useKeyEvent(ACTIVE_GLOBAL_SEARCH_KEY, t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async e => {
      e.preventDefault();
      setIsSearchActive(_temp);
    };
    t3 = <IconSearch2 />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] !== isSearchActive) {
    t4 = <Tooltip message="Search" command="/" positionTip="bottom" offset="5px"><ToolbarButton tabIndex={0} title="Search" data-active={isSearchActive} onClick={t2}>{t3}</ToolbarButton></Tooltip>;
    t5 = isSearchActive && <Portal name="global-search"><GlobalSearch setIsSearchActive={setIsSearchActive} /></Portal>;
    $[4] = isSearchActive;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(isActive) {
  return !isActive;
}